var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLgbt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.6666667px",
    height: "7.33333333px",
    viewBox: "0 0 14.6666667 7.33333333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_looks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,2.66666667 C4.76,2.66666667 2.66666667,4.76 2.66666667,7.33333333 L4,7.33333333 C4,5.49333333 5.49333333,4 7.33333333,4 C9.17333333,4 10.6666667,5.49333333 10.6666667,7.33333333 L12,7.33333333 C12,4.76 9.90666667,2.66666667 7.33333333,2.66666667 L7.33333333,2.66666667 Z M7.33333333,0 C3.28666667,0 0,3.28666667 0,7.33333333 L1.33333333,7.33333333 C1.33333333,4.02666667 4.02666667,1.33333333 7.33333333,1.33333333 C10.64,1.33333333 13.3333333,4.02666667 13.3333333,7.33333333 L14.6666667,7.33333333 C14.6666667,3.28666667 11.38,0 7.33333333,0 L7.33333333,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThemaBadge/Round/LGTB",
    transform: "translate(-8.666667, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_looks",
    transform: "translate(8.666667, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#2800A0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.333333, -12.666667)",
    id: "Color/HV/Primary"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 33.3333333,
    height: 33.3333333
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgbt);
export default __webpack_public_path__ + "static/media/LGBT.863a0e77694910c1dd4c347fc08c2332.svg";
export { ForwardRef as ReactComponent };